import API from "@/api";

export const moduleName = "blog";

export const actionTypes = {
  ACTION_LOAD_BLOGS: "ACTION_LOAD_BLOGS",
  ACTION_ADD_BLOG: "ACTION_ADD_BLOG",
  ACTION_EDIT_BLOG: "ACTION_EDIT_BLOG",
  ACTION_DELETE_BLOG: "ACTION_DELETE_BLOG"
};

export const getterTypes = {
  GETTER_BLOGS: "GETTER_BLOGS",
  GETTER_BLOGS_COUNT: "GETTER_BLOGS_COUNT",
  GETTER_PAGE_RELOAD: 'GETTER_PAGE_RELOAD'
};

export const mutationTypes = {
  SET_BLOGS_DATA: "SET_BLOGS_DATA",
  SET_BLOG: "SET_BLOG",
  UPDATE_BLOG: "UPDATE_BLOG",
  DELETE_BLOG: "DELETE_BLOG",
  MUTATION_SET_PAGE_RELOAD: 'MUTATION_SET_PAGE_RELOAD',
};

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    blogs: [],
    blogsCount: 0,
    isPageReload: false
  }),

  actions: {
    async [actionTypes.ACTION_LOAD_BLOGS]({ commit }, payload) {
      const response = await API.blogManager.loadBlogs(payload);
      const { blogs, count } = response.data;
      commit(mutationTypes.SET_BLOGS_DATA, [blogs, count]);
    },
    async [actionTypes.ACTION_ADD_BLOG]({ commit }, payload) {
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, false )

      const { data: blog } = await API.blogManager.addBlog(payload);
      commit(mutationTypes.SET_BLOG, blog);
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true )
    },
    async [actionTypes.ACTION_EDIT_BLOG]({ commit }, { blogId, blog }) {
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, false )

      const { data } = await API.blogManager.editBlog(blogId, blog);
      commit(mutationTypes.UPDATE_BLOG, data);
      console.log("ACTION_EDIT_BLOG", data)
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true )
    },
    async [actionTypes.ACTION_DELETE_BLOG]({ commit }, { blogId }) {
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, false )

      await API.blogManager.deleteBlog(blogId);
      commit(mutationTypes.DELETE_BLOG, blogId);
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true )
    }
  },

  mutations: {
    [mutationTypes.SET_BLOGS_DATA](state, [blogs, blogsCount]) {
      if (Array.isArray(blogs)) {
        state.blogs = blogs;
      }
      if (!isNaN(blogsCount)) {
        state.blogsCount = blogsCount;
      }
    },
    [mutationTypes.SET_BLOG](state, blog) {
      // state.blogs.pop();
      state.blogs.unshift(blog);
      state.blogsCount++;
    },
    [mutationTypes.UPDATE_BLOG](state, blog) {
      const index = state.blogs.findIndex(b => b.id === blog.id);
      if (index === -1) return;
      state.blogs.splice(index, 1, blog);
    },
    [mutationTypes.DELETE_BLOG](state, blogId) {
      const index = state.blogs.findIndex(b => b.id === blogId);
      if (index === -1) return;
      state.blogs.splice(index, 1);
    },
    [mutationTypes.MUTATION_SET_PAGE_RELOAD](state, pageReload) {
      state.isPageReload = pageReload
    },
  },

  getters: {
    [getterTypes.GETTER_BLOGS]: state => state.blogs,
    [getterTypes.GETTER_BLOGS_COUNT]: state => state.blogsCount,
    [getterTypes.GETTER_PAGE_RELOAD]: (state) => state.isPageReload,

  }
};
